import axios from "axios";

export async function sendData(formValues, truck, mensalidade, motivo) {
  var dayjs = require("dayjs");
  const date = dayjs().toISOString();
  
  if (formValues.email === "undefined" || formValues.email === "") {
    formValues.email = "Sem e-mail";
  }
  if (formValues.Marca === undefined) {
    formValues.Marca = "Sem marca";
  }
  if (formValues.Modelo === undefined) {
    formValues.Modelo = "Sem modelo";
  }
  if (formValues.AnoModelo === undefined) {
    formValues.AnoModelo = "Sem ano";
  }
  if (formValues.AnoModelo === 32000) {
    formValues.AnoModelo = "Zero";
  }
  if (formValues.Valor === undefined) {
    formValues.Valor = "Sem valor";
  }
  if (truck === undefined) {
    truck = "Sem resposta";
  }
  if (motivo === undefined) {
    motivo = "Sem resposta";
  }
  const cotacao = ` Marca:${formValues.Marca}, Modelo${formValues.Modelo}, Ano:${formValues.AnoModelo}, 
  Valor:${formValues.Valor},Mensalidade:${mensalidade}, ${truck}, ${motivo}`;

  const apiConfig = {
    headers: {
      apikey: "0bd11cb2-42b6-4e97-b132-f2b6c8c3f312",
      "Content-Type": "application/json",
      "X-Moskit-Origin": "WEB",
    }
  };

  try {
    // Busca usando o endpoint de pesquisa correto
    const searchResponse = await axios.post(
      "https://api.moskitcrm.com/v2/contacts/search",
      [{
        field: "emails",
        expression: "like",
        values: [formValues.email]
      }],
      apiConfig
    );
    
    let contactId;
    console.log("Pesquisando email:", formValues.email);
    
    // Verifica se encontrou algum contato
    if (searchResponse.data && searchResponse.data.length > 0) {
      contactId = searchResponse.data[0].id;
      console.log("Contato encontrado com ID:", contactId);
    } else {
      console.log("Email não encontrado, criando novo contato...");
      const contactResponse = await axios.post(
        "https://api.moskitcrm.com/v2/contacts",
        {
          id: 0,
          createdBy: { id: 59727 },
          responsible: { id: 59727 },
          name: formValues.name,
          emails: [{ address: formValues.email }],
          phones: [{ number: formValues.phone }],
          entityCustomFields: [{
            id: "CF_8P5q4aS2CAG38MRJ",
            textValue: cotacao,
            options: [0]
          }]
        },
        apiConfig
      );
      contactId = contactResponse.data.id;
      console.log("Novo contato criado com ID:", contactId);
    }

    // Criar negócio
    const dealResponse = await axios.post(
      "https://api.moskitcrm.com/v2/deals",
      {
        id: 0,
        createdBy: { id: 59727 },
        responsible: { id: 59727 },
        dateCreated: date,
        name: formValues.name,
        source: "WEB",
        origin: "WEB",
        status: "OPEN",
        price: mensalidade,
        contact: { id: contactId },
        entityCustomFields: [
          { id: "CF_dVKmQ5i1CdZOLmWR", textValue: formValues.Marca },
          { id: "CF_A4wMWNigC6NW4qB8", textValue: formValues.Modelo },
          { id: "CF_6rRmweivC67xZq4X", textValue: formValues.AnoModelo },
          { id: "CF_K7Rm8QiRCK6v6DbN", textValue: formValues.Valor },
          { id: "CF_2ojMxLiPCZaK7MOE", textValue: formValues.email },
          { id: "CF_gvGm3Bi0CzRdKM45", textValue: formValues.phone },
          { id: "CF_gvGm3Bi0CzPPGM45", textValue: truck },
          { id: "CF_Rg7MnEiLCA7leqvd", textValue: "NovaCotacao" },
          { id: "CF_Rg7MnEiLCANo8qvd", textValue: motivo }
        ],
        stage: { id: 178196 }
      },
      apiConfig
    );
  console.log("Negócio criado com ID:", dealResponse.data.id);
    return dealResponse.data.id;
  } catch (error) {
    console.error("Erro ao processar a requisição:", error);
  }
}

export default sendData;